import React from 'react';
import { addQueryString, qsToObject, masonryOptions, defaultMapState } from './utils'
import GoogleMap from './GoogleMap'




const RoutesMap = () => {

  const [response, setresponse] = React.useState();
  const [hits, sethits] = React.useState();
  const [view, setview] = React.useState(localStorage.getItem("view") || 'list-view');


  const [showLoader, setshowLoader] = React.useState(false)
  const [updateFilters, setupdateFilters] = React.useState(false)

  const queriesObject = qsToObject(window.location.search);


  let config = window.routesMapConfig;






  React.useEffect(() => {
    //    if (inView) {


    console.log("use effect run")








    setshowLoader(true)
    //console.log(`${config.apiUrl}?parentPageId=2529&pageNumber=1&pagesize=100&eventTypeId=3529&filterDate=&searchTerm=&culture=en-US`)
    let apiUrl = `${config.apiUrl}?componentId=${config.componentId}&locationId=${queriesObject.locationId || config.locationId}&traineeId=${queriesObject.traineeId || config.traineeId}&culture=${config.culture}`


    fetch(apiUrl)
      .then(result => result.json())
      .then(
        (result) => {

          console.log(result)

          setresponse(result)

          //     console.log(result.ciag_items)
          sethits(result && result.ciag_items)


          // setupdateFilters(false)


          setshowLoader(false)

        },
        (error) => {
          setshowLoader(false)
          console.error(error)
        }
      )
    //   }
  }, [])

 const markerCallback = ()=>{
    console.log("marker clicked")
  }
  return (
    <div >


      <div className="section download">
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-10 offset-lg-1">
              <div className="row">
                <div className="col-8">
                  <GoogleMap mapState={hits} markerCallback={markerCallback} SeeDetails={"GET DIRECTIONS"} Distance={'7.5 KM'} routeMap={true} />
                </div>
                <div className="col-4">
                  <div className="download-listing">
                  <h3>Choose Your Track</h3>
                    <ul>

                      {hits && hits.map((item, index) => {
                        return <li onClick={markerCallback} key={index}>
                          {item.title}</li>
                      })}
                     

                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>


    </div>
  )
}


export default RoutesMap;
